import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { timer } from 'rxjs';
import { InitService } from './init.service';
import { AdsItem, Message } from './interfaces';
import { MessageService } from './services/message.service';
import { GOOGLE_ANALYTICS_TRACKING_CODE, HOST, SITE_ID } from './tokens';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	message: Message = null;
	cookiePolicyVisible: boolean = false;
	floatingAds: AdsItem | null = null;
	stickyAds: AdsItem | null = null;

	hideCookiePolicy(): void {
		this.cookiePolicyVisible = false;
		this.cookieService.set('civispopupcookiepolicy', '1', 365, '/');
	}

	closeMessage(): void {
		this.messageService.onMessage.next(null);
	}

	insertGa(): void {
		const script: HTMLScriptElement = this.document.createElement('script');
		script.async = true;
		script.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.googleAnalyticsTrackingCode;
		script.onload = () => {
			const innerScript: HTMLScriptElement = this.document.createElement('script');
			innerScript.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${this.googleAnalyticsTrackingCode}');
			`;
			this.document.head.appendChild(innerScript);
		}
		this.document.head.appendChild(script);
	}

	initPopupAds(): void {
		if (this.initService.floatingAds === null) {
			return;
		}
		if (this.cookieService.check('civisfloating')) {
			return;
		}

		timer((this.initService.floatingAds.delay || 0) * 1000).subscribe(() => {
			this.floatingAds = this.initService.floatingAds;
			if (this.floatingAds.duration !== null) {
				timer(this.floatingAds.duration * 1000).subscribe(() => {
					this.floatingAds = null;
				});
			}
		});
	}

	initStickyAds(): void {
		if (this.initService.stickyAds === null) {
			return;
		}
		this.stickyAds = this.initService.stickyAds;
	}

	hideStickyAd(): void {
		this.stickyAds = null;
	}

	initNetAdClickSoonScript(): void {

		if (this.document === null) {
			return;
		}

		if (isPlatformBrowser(this.platformId)) {

			const window: Window | null = this.document.defaultView;
			if (window === null) {
				return;
			}

			let code: number = 321;
			switch (this.siteId) {
				case 1: code = 321; break;
				case 2: code = 322; break;
				case 3: code = 323; break;
			}

			const h: string = 'https://apiv2.indidata.com/';
			const p: URLSearchParams = new URLSearchParams(this.document.location.search);
			const db: boolean = p.get('netaddebug') === 'true';
			const dbg = (...args: any[]): void => {
				if (db) {
					(window as any)?.console?.log(args);
				}
			}
			const a: string | null = p.get('indidn');
			const n: string | null = p.get('nlcidn');
			const i: string | null = a || n;
			if (i === null) {
				dbg('[IndiData] Korai validálás: nincs kampány paraméter (indidn/nlcidn), kihagyva');
				return;
			}

			const s: string = a !== null ? 'ad' : 'nl';
			try {
				window.localStorage.setItem('indidata_click_context', JSON.stringify({ source: s, indidn: i, exp: Date.now() + 1728e5 }))
			} catch (e) { }

			const send = (pv: number, vt: number): void => {
				var u = h.replace(/\/?$/, '/') + 'clickvalidate.php?indidn=' + encodeURIComponent(i) + '&source=' + encodeURIComponent(s) + '&oldal_id=' + encodeURIComponent(code) + '&oldal_pageview=' + pv + '&oldal_viewtime=' + vt;
				if (window.navigator.sendBeacon && window.navigator.sendBeacon(u, '')) return;
				(new Image).src = u + '&_=' + Date.now()
			};

			send(1, 0);

			try {
				window.sessionStorage.setItem('indidata_cv_init', '1')
			} catch (e) { }
			dbg('[IndiData] Korai validálás: validálva', { indidn: i, source: s });
			window.setTimeout(function () {
				if (window.document.visibilityState === 'hidden') {
					dbg('[IndiData] Korai validálás: 5 mp nem teljesült (oldal elhagyva)'); return
				}
				send(0, 5);
				try {
					window.sessionStorage.setItem('indidata_cv_viewtime', '1')
				} catch (e) { }
				dbg('[IndiData] Korai validálás: 5 mp teljesítve')
			}, 5e3)
		}
	}

	initIndiDataTracking(): void {

		let code: number = 321;
		switch (this.siteId) {
			case 1: code = 321; break;
			case 2: code = 322; break;
			case 3: code = 323; break;
		}

		const script: HTMLScriptElement = this.document.createElement('script');
		script.async = true;
		script.type = 'text/javascript';
		script.innerHTML = `
			(function(){try{var p=new URLSearchParams(location.search),a=p.get('indidn'),n=p.get('nlcidn'),i=a||n;if(i)localStorage.setItem('indidata_click_context',JSON.stringify({source:a?'ad':'nl',indidn:i,exp:Date.now()+1728e5}))}catch(e){}})();
			window.eventStorage = window.eventStorage || [];
			(function(w,d,s,u,i){
				var ts = Math.floor(Date.now() / (1000 * 60 * 5));
				var f = d.getElementsByTagName(s)[0],
					j = d.createElement(s);
				j.async = true;
				j.src = u + "?v=" + ts;
				j.setAttribute("data-endhost", "https://apiv2.indidata.com/");
				j.setAttribute("data-id", i);
				f.parentNode.insertBefore(j,f);
			})(window,document,"script","https://apiv2.indidata.com/manager.js", ${code});
		`;
		this.document.head.appendChild(script);
	}

	getFloatingAdAnimation(): string {
		if (this.floatingAds === null) {
			return 'none';
		}
		switch (this.floatingAds.animation) {
			case 'FROM_TOP': return 'fromTop';
			case 'FROM_LEFT': return 'fromLeft';
			case 'FROM_RIGHT': return 'fromRight';
			case 'FROM_BOTTOM': return 'fromBottom';
			case 'ZOOM_IN': return 'zoomIn';
		}
		return 'none';
	}

	hideFloatingAd(): void {
		this.floatingAds = null;
		this.cookieService.set('civisfloating', '1', 1, '/');
	}

	ngOnInit(): void {
		if (isPlatformBrowser(this.platformId)) {
			this.cookiePolicyVisible = !this.cookieService.check('civispopupcookiepolicy');
			if (!this.cookiePolicyVisible) {
				if (this.initService.floatingAds !== null) {
					this.initPopupAds();
				} else {
					this.initStickyAds();
				}
			}
		}
		this.messageService.onMessage.subscribe((message: Message) => {
			this.message = message;
		});
	}

	constructor(
		private messageService: MessageService,
		private cookieService: CookieService,
		private initService: InitService,
		@Inject(PLATFORM_ID) private platformId: Object,
		@Inject(SITE_ID) private siteId: number,
		@Inject(DOCUMENT) private document: Document,
		@Inject(GOOGLE_ANALYTICS_TRACKING_CODE) private googleAnalyticsTrackingCode: string,
		@Inject(HOST) private host: string
	) {
		this.insertGa();
		this.initNetAdClickSoonScript();
		this.initIndiDataTracking();
	}
}
